// extracted by mini-css-extract-plugin
module.exports = {"main-content":"layout_main-content__w448h"};